import $ from 'jquery'

export default () => {
    return {
        scrollPosition: 0,
        pageHeight: document.body.scrollHeight,
        isAtBottom: (window.innerHeight + window.scrollY) >=
            document.body.scrollHeight,
        isCTAVisible: false,
        get percentageScrolled () {
            let scrollPosition = this.scrollPosition
            const rect = this.$el.getBoundingClientRect()
            const windowHeight = window.innerHeight
            const height = windowHeight + rect.height
            scrollPosition = windowHeight - rect.top

            return (scrollPosition / height) * 100
        },
        get hasScrolled () {
            return this.scrollPosition > 10
        },
        init () {
            const cta = document.querySelector('#cta-section')

            if (cta) {
                const observer = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            setTimeout(() => {
                                this.isCTAVisible = true
                            }, 1000)
                        } else {
                            this.isCTAVisible = false
                        }
                    })
                }, {
                    root: null,
                    threshold: 0,
                })
                observer.observe(cta)
            }
            window.addEventListener('scroll', () => {
                this.scrollPosition = window.scrollY
                this.isAtBottom = (window.innerHeight + window.scrollY) >=
                    document.body.scrollHeight
            })
        },
        mobileMenu: {
            isOpen: false,
            scrollbarWidth: null,
            open () {
                this.scrollbarWidth = getScrollbarWidth()
                this.isOpen = true
            },
            close () {
                this.isOpen = false
            },
            toggle () {
                this.isOpen = !this.isOpen
            },
        },
    }
}

function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
}
